export const CRM_ENRICHMENT_BASE_QUERY_KEY = "crm-enrichment";
